import BasicDialog from "../../base/BasicDialog";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { useAsyncFn } from "../../../hooks/useAsync";
import { useSnackbarAlert } from "../../../context/snackbarAlert";
import PostForm from "../../form/PostForm/PostForm";
import useCorrespondenceService from "../../../services/correspondenceService";
import React, { useEffect, useState } from "react";

const PostDataWindow = (props) => {
  const { t } = useTranslation();
  const { createNewPost, updatePostData } = useCorrespondenceService();
  const createPostFn = useAsyncFn(createNewPost);
  const updatePostFn = useAsyncFn(updatePostData);
  const snackbarAlert = useSnackbarAlert();

  const onSubmit = (newPostData) => {

    if (newPostData.id) {
      updatePostFn
        .execute(newPostData.id, newPostData)
        .then((res) => {
          snackbarAlert.openSuccessSnackbarAlert(t("snackbar_alert.post_updated"));
          if (props.onRefetchData) {
            props.onRefetchData();
          }
          props.onClose(true);
        })
        .catch((error) => {
          snackbarAlert.openErrorSnackbarAlert(
            t("snackbar_alert.occurred_error_during_updating_post")
          );
        });
    } else {
      createPostFn
        .execute(newPostData)
        .then((res) => {
          snackbarAlert.openSuccessSnackbarAlert(t("snackbar_alert.post_created"));
          if (props.onRefetchData) {
            props.onRefetchData();
          }
          props.onClose(true);
        })
        .catch((error) => {
          snackbarAlert.openErrorSnackbarAlert(t("snackbar_alert.occurred_error_during_creating_new_post"));
        });
    };
  }
  return (
      <PostForm
        onSubmit={onSubmit}
        loadingSubmitButton={createPostFn.loading}
        readOnly={props.readOnly}
        postIn={props.postIn}
        formValue={props.formValue}
        postId={props.postId}
        autocompleteData={props.autocompleteData}
        xs={props.xs}
      />
  );
};

PostDataWindow.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onRefetchData: PropTypes.func,
  readOnly: PropTypes.bool,
  postIn: PropTypes.bool.isRequired,
  formValue: PropTypes.object
};

PostDataWindow.defaultProps = {
  readOnly: false,
};

export default PostDataWindow;
